import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const addColumnAfterCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).addColumnAfter().run() : editor.chain().focus().addColumnAfter().run();

const AddColumnAfter = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<ArrowRightOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => addColumnAfterCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_ADD_COL_AFTER" defaultMessage="Add column after" />
        </div>
      )}
    </Button>
  );
};

export default AddColumnAfter;
